module.exports = require('./helpers/bundle-url').getBundleURL('5cKF3') + "logo-dark.ba5147f0.svg";